namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHdActGrid extends Serenity.EntityGrid<PsAdvPromoHdActRow, any> {
        protected getColumnsKey() { return PsAdvPromoHdActColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHdActDialog; }
        protected getIdProperty() { return PsAdvPromoHdActRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHdActRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHdActRow.localTextPrefix; }
        protected getService() { return PsAdvPromoHdActService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }



        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }

    protected getQuickFilters() {
        let filters = super.getQuickFilters();
        
        filters.push({
            field: 'EndPromoDate',
            type: Serenity.DateEditor,
            title: 'กำหนดวันที่แสดงโปร',
            handler: h => {
                if (h.active && h.value) {
                    h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                        [['EndPromoDate'], '>=', h.value],
                        [['StartPromoDate'], '<=', h.value]
                    );
                }
            },
            init: w => {
                (w as Serenity.DateEditor).valueAsDate = new Date();
            }
        });

        return filters;
    }
    }
}